// extracted by mini-css-extract-plugin
export default {"container":"Physiotherapist_container__AkUPB","linkBoxes":"Physiotherapist_linkBoxes__RV0ky","linkBox":"Physiotherapist_linkBox__mFiS8","boxes":"Physiotherapist_boxes__w103T"};